/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InventoryService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Add stock to a warehouse
     * @returns any Stock movement created
     * @throws ApiError
     */
    public addStock({
        requestBody,
    }: {
        requestBody?: {
            warehouse_id: string;
            barcode_or_item_id: string;
            quantity: number;
            bin_id?: string;
        },
    }): CancelablePromise<{
        movement_id: string;
        item_id: string;
        warehouse_id: string;
        bin_id?: string;
        quantity: number;
        balance_after: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/add',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Personal user account required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Remove stock from a warehouse
     * @returns any Stock movement created
     * @throws ApiError
     */
    public removeStock({
        requestBody,
    }: {
        requestBody?: {
            warehouse_id: string;
            item_id: string;
            quantity: number;
            bin_id?: string;
            owner_override?: boolean;
            request_owner_approval?: boolean;
        },
    }): CancelablePromise<{
        success: boolean;
        movement_id: string;
        item_id: string;
        warehouse_id: string;
        bin_id?: string;
        quantity_removed: number;
        balance_after: number;
        owner_override_applied: boolean;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/remove',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Owner override required`,
                404: `Resource not found`,
                422: `Insufficient stock requires owner approval`,
            },
        });
    }
    /**
     * Transfer stock between warehouses
     * @returns any Transfer movement created
     * @throws ApiError
     */
    public transferStock({
        requestBody,
    }: {
        requestBody?: {
            item_id: string;
            quantity: number;
            source_warehouse_id: string;
            dest_warehouse_id: string;
            source_bin_id?: string;
            dest_bin_id?: string;
        },
    }): CancelablePromise<{
        movement_id: string;
        item_id: string;
        quantity: number;
        source_warehouse_id: string;
        dest_warehouse_id: string;
        source_balance_after: number;
        dest_balance_after: number;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Personal user account required`,
                404: `Resource not found`,
                422: `Insufficient stock`,
            },
        });
    }
    /**
     * Adjust inventory to a physical count
     * @returns any Count adjustment movement created
     * @throws ApiError
     */
    public countAdjust({
        requestBody,
    }: {
        requestBody?: {
            warehouse_id: string;
            bin_id?: string;
            item_id: string;
            observed_quantity: number;
        },
    }): CancelablePromise<{
        movement_id: string;
        item_id: string;
        previous_balance: number;
        new_balance: number;
        delta: number;
        movement_type: 'COUNT_ADJUSTMENT';
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/count-adjust',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Personal user account required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * Create a manual adjustment movement (owner only)
     * @returns any Manual adjustment movement created
     * @throws ApiError
     */
    public createManualMovement({
        requestBody,
    }: {
        requestBody?: {
            item_id: string;
            warehouse_id: string;
            bin_id?: string;
            quantity: number;
            note?: string;
            occurred_at?: string;
        },
    }): CancelablePromise<{
        movement_id: string;
        type: 'MANUAL_ADJUSTMENT';
        item_id: string;
        warehouse_id: string;
        bin_id?: string;
        quantity: number;
        note?: string;
        occurred_at?: string;
        created_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/movements',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Owner role required`,
                404: `Resource not found`,
            },
        });
    }
    /**
     * List movement transactions (owner only)
     * @returns any Movement transactions
     * @throws ApiError
     */
    public listMovements({
        warehouseId,
        dateFrom,
        dateTo,
        limit = 50,
        offset,
    }: {
        warehouseId?: string,
        dateFrom?: string,
        dateTo?: string,
        limit?: number,
        offset?: number | null,
    }): CancelablePromise<Array<{
        id: string;
        type: 'ADD' | 'REMOVE' | 'TRANSFER' | 'COUNT_ADJUSTMENT' | 'MANUAL_ADJUSTMENT';
        item_id: string;
        item_name: string;
        quantity: number;
        source_warehouse_id?: string;
        source_warehouse_name?: string;
        source_bin_id?: string;
        source_bin_name?: string;
        dest_warehouse_id?: string;
        dest_warehouse_name?: string;
        dest_bin_id?: string;
        dest_bin_name?: string;
        user_id: string;
        user_name?: string;
        note?: string;
        occurred_at?: string;
        created_at: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/inventory/movements',
            query: {
                'warehouse_id': warehouseId,
                'date_from': dateFrom,
                'date_to': dateTo,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication required`,
                403: `Owner role required`,
            },
        });
    }
    /**
     * Get inventory balances
     * @returns any Inventory balances
     * @throws ApiError
     */
    public getInventoryBalance({
        warehouseId,
        binId,
        itemId,
    }: {
        warehouseId?: string,
        binId?: string,
        itemId?: string,
    }): CancelablePromise<Array<{
        warehouse_id: string;
        bin_id?: string;
        item_id: string;
        quantity: number;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/inventory/balance',
            query: {
                'warehouse_id': warehouseId,
                'bin_id': binId,
                'item_id': itemId,
            },
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * Get current stock levels per item grouped by warehouse and bin
     * @returns any Current stock levels per item
     * @throws ApiError
     */
    public getCurrentBalance({
        warehouseId,
        sku,
    }: {
        warehouseId?: string,
        sku?: string,
    }): CancelablePromise<Array<{
        item_id: string;
        item_name: string;
        skus: Array<string>;
        total_quantity: number;
        warehouses: Array<{
            warehouse_id: string;
            warehouse_name: string;
            quantity: number;
            bins: Array<{
                bin_id: string;
                bin_name: string;
                quantity: number;
            }>;
        }>;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/inventory/current-balance',
            query: {
                'warehouse_id': warehouseId,
                'sku': sku,
            },
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * Download current stock levels as CSV
     * @returns string CSV file
     * @throws ApiError
     */
    public downloadCurrentBalanceCsv({
        warehouseId,
        sku,
    }: {
        warehouseId?: string,
        sku?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/inventory/current-balance.csv',
            query: {
                'warehouse_id': warehouseId,
                'sku': sku,
            },
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * List shortfall removal approvals visible to the current user
     * @returns any Visible removal approvals
     * @throws ApiError
     */
    public getRemovalApprovals(): CancelablePromise<Array<{
        id: string;
        item_id: string;
        item_name: string;
        warehouse_id: string;
        warehouse_name: string;
        bin_id?: string;
        bin_name?: string;
        quantity_requested: number;
        current_balance: number;
        shortfall: number;
        status: 'pending' | 'approved' | 'rejected';
        requested_by_user_id: string;
        requested_by_name: string;
        approved_by_owner_id?: string;
        approved_by_owner_name?: string;
        movement_id?: string;
        created_at: string;
        decided_at?: string;
    }>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/inventory/removal-approvals',
            errors: {
                401: `Authentication required`,
            },
        });
    }
    /**
     * Approve a shortfall removal request
     * @returns any Removal approval processed
     * @throws ApiError
     */
    public approveRemovalApproval({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        approval_id: string;
        status: 'pending' | 'approved' | 'rejected';
        movement_id?: string;
        decided_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/removal-approvals/{id}/approve',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `Owner role required`,
                404: `Approval not found`,
                409: `Approval already processed`,
            },
        });
    }
    /**
     * Reject a shortfall removal request
     * @returns any Removal approval rejected
     * @throws ApiError
     */
    public rejectRemovalApproval({
        id,
    }: {
        id: string,
    }): CancelablePromise<{
        approval_id: string;
        status: 'pending' | 'approved' | 'rejected';
        movement_id?: string;
        decided_at: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/inventory/removal-approvals/{id}/reject',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `Owner role required`,
                404: `Approval not found`,
                409: `Approval already processed`,
            },
        });
    }
}
